var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.18 125.253C250.18 159.005 236.808 189.625 215.051 212.112C192.325 235.624 160.456 250.246 125.173 250.246C90.0443 250.246 58.3009 235.751 35.603 212.435C13.6776 189.906 0.179688 159.174 0.179688 125.253C0.179688 56.2183 56.1379 0.246094 125.173 0.246094C194.207 0.246094 250.18 56.2183 250.18 125.253Z",
    fill: "#C2C8CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.052 212.112C192.326 235.624 160.456 250.246 125.173 250.246C90.0448 250.246 58.3014 235.751 35.6035 212.435C41.278 190.299 58.3295 169.357 78.7941 160.789C83.4854 158.822 86.4631 158.724 90.5645 162.193C108.922 177.7 140.427 180.453 160.976 161.14C164.122 158.19 166.861 158.443 170.19 159.988C189.011 168.809 209.251 188.88 215.052 212.112Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0356 71.5282C111.239 38.8017 159.641 46.8358 175.836 86.9504C182.929 104.522 177.437 128.104 163.096 142.529C146.522 159.188 126.451 161.898 105.41 154.932C85.5076 148.344 72.6558 128.147 72.5574 107.485C72.5434 103.721 72.4591 99.9708 72.417 96.2066C74.6924 87.442 76.0829 78.2842 83.0356 71.5282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDefault);
export default __webpack_public_path__ + "static/media/profile_default.b2f2085ce43897606dc97adb854e2b1c.svg";
export { ForwardRef as ReactComponent };